module.exports = __webpack_public_path__ + "europa-5_watermark.jpg?7e1bae3102a5c23cf9ee0b8cd1f08ea8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_watermark.jpg
// module id = 397
// module chunks = 0